<script setup>
import { computed, watch } from "vue"
import { stringNumber } from '../../helpers/functions.js'
import { storage } from '../../storage'
// import { aliensTypes } from '../../staticData'

const props = defineProps(['task', 'keyName'])
const emits = defineEmits(['new-achievement'])

const taskValue = computed(() => props.task.values[storage.ACHIEVEMENTS[props.keyName]] ? props.task.values[storage.ACHIEVEMENTS[props.keyName]] : props.task.values[storage.ACHIEVEMENTS[props.keyName] - 1])
const theDescription = computed(() => props.task.description.replace('[value]', stringNumber(taskValue.value, true)))

// const rowsNum = computed(() => props.value.aliens ? props.value.aliens : [null])
const getUrl = computed(() => `/spacebar-clicker/assets/${props.task.imgUrl}`)
const progress = computed(() => {
    let res = 0
    switch (props.keyName) {
        case 'Just Jelly':
        case 'Grumpy Jelly':
        case 'Lovely Jelly':
        case 'Amazed Jelly':
        case 'Sleepy Jelly':
            res = storage.ALIENS_OWNED[props.keyName].amount
            break;
        case 'RICHNESS':
            res = storage.COINS
            break;
        default:
            res = storage[props.keyName]
            break;
    }
    if (res > taskValue.value) res = taskValue.value
    return res;
})
const amountInPers = computed(() => Number(progress.value) * 100 / Number(taskValue.value) + '%')
const isAchieved = computed(() => BigInt(progress.value) >= BigInt(taskValue.value))
watch(isAchieved, () => {
    if (isAchieved.value) emits('new-achievement')
})
function collectAward() {
    storage.PINK_COINS += props.task.award[storage.ACHIEVEMENTS[props.keyName]].pinkC
    storage.BLACK_COINS += props.task.award[storage.ACHIEVEMENTS[props.keyName]].blackC
    storage.ACHIEVEMENTS[props.keyName] += 1
}
</script>

<template>
    <div class="item" >
        <div class="img-wrap">
            <img :src="getUrl" alt="">
        </div>
        <template v-if="task.values[storage.ACHIEVEMENTS[keyName]]">
            <div class="task-wrap">
                <p>{{ theDescription }}</p>
                <div class="range">
                    <span class="text">{{ stringNumber(progress, true) }}/{{ stringNumber(taskValue, true) }}</span>
                    <span class="full"></span>
                </div>
            </div>
            <div class="reward-wrap" :class="{ 'unlocked': isAchieved }" @click="collectAward">
                <p v-show="isAchieved"><img class="coin-sm" src="/spacebar-clicker/assets/balls/ball_1.png" alt="">{{ task.award[storage.ACHIEVEMENTS[keyName]].pinkC }}</p>
                <p v-show="isAchieved"><img class="coin-sm" src="/spacebar-clicker/assets/balls/ball_9.png" alt="">{{ task.award[storage.ACHIEVEMENTS[keyName]].blackC }}</p>
                <p v-show="isAchieved">Claim</p>
                <span class="quest" v-show="!isAchieved">?</span>
            </div>
        </template>
        <div class="col" v-else style="width: 80%;">
            <p class="achieved">COMPLETED</p>
            <p>{{ theDescription }}</p>
        </div>
    </div>
</template>

<style scoped>
.item {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    /* margin: 5px; */
    overflow: visible;
    background-color: #15296c;
    /* border: 1px solid blue; */
    border-radius: 20px;
}

.img-wrap {
    width: 15%;
    min-width: 55px;
}

.img-wrap img {
    height: 50px;
    width: auto
}

.task-wrap {
    width: calc(80% - 70px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.task-wrap p {
    line-height: 1.3rem;
    margin-bottom: 5px;
}

.range {
    position: relative;
    width: 95%;
    height: 1rem;
    border-radius: 10px;
    background-color: antiquewhite;
}

.range span.text {
    color: black;
    font-size: 1rem;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

span.full {
    display: block;
    width: v-bind(amountInPers);
    height: 100%;
    background-color: yellow;
}

.reward-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 5px;
    width: 60px;
    height: 60px;
    border-radius: 30%;
    background: linear-gradient(40deg, yellow, white);
    box-shadow: -2px 3px 0px 1px rgb(255, 196, 0);
    filter: brightness(0.85);
    /* border-bottom: 1px solid white; */
}

.reward-wrap.unlocked {
    filter: brightness(1);
}

.reward-wrap.unlocked:hover {
    cursor: pointer;
    box-shadow: 0 0 8px 8px yellow;
}

span.quest {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: rgb(245, 231, 231);
    font-size: 3rem;
}

.quest:hover {
    cursor: default;
}

.reward-wrap p {
    color: black;
}

p.achieved {
    font-size: 2rem;
    /* left: 15%; */
    position: relative;
    /* transform: translateX(-50%); */
    color: red;
}


@media screen and (max-width: 800px) {

    /* span.quest {
        top: 20px;
        right: 35px;
    } */

}
</style>